import React, { useState } from 'react';
import '../../styles/CustomerSiteStyles/FAQ.css';

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const faqItems = [
    {
      question: 'What types of roofing services do you offer?',
      answer: 'We offer a wide range of roofing services including roof repairs, roof replacements, roof inspections, and emergency roofing services.'
    },
    {
      question: 'How do I know if my roof needs repair or replacement?',
      answer: 'Common signs that your roof may need repair or replacement include missing or broken shingles, leaks, sagging, and visible wear and tear. We recommend scheduling a professional inspection to assess the condition of your roof.'
    },
    {
      question: 'Do you offer free estimates?',
      answer: 'Yes, we offer free, no-obligation estimates for all our roofing services. Contact us today to schedule your estimate.'
    },
    {
      question: 'How long does a roof replacement typically take?',
      answer: 'The duration of a roof replacement project depends on the size and complexity of the roof. On average, a standard roof replacement can take anywhere from 1 to 3 days.'
    },
    {
      question: 'What materials do you use for roofing?',
      answer: 'We use a variety of high-quality roofing materials including asphalt shingles, metal roofing, tile, and slate. We can help you choose the best material for your home and budget.'
    },
    {
      question: 'Do you provide warranties for your roofing work?',
      answer: 'Yes, we provide warranties for both materials and workmanship. The specifics of the warranty will depend on the type of roofing material and the scope of the project.'
    },
    {
      question: 'Can you help with insurance claims for roof damage?',
      answer: 'Yes, we can assist you with the insurance claims process. We will work with your insurance company to ensure that your roof is repaired or replaced as needed.'
    },
    {
      question: 'What areas do you serve?',
      answer: 'We serve residential and commercial clients in [Your City/Region]. Contact us to see if we service your area.'
    }
  ];

  return (
    <div className="faq-container">
      <h1>Frequently Asked Questions</h1>
      <div className="faq-list">
        {faqItems.map((item, index) => (
          <div key={index} className="faq-item">
            <button
              className={`faq-question ${activeIndex === index ? 'active' : ''}`}
              onClick={() => toggleFAQ(index)}
            >
              {item.question}
            </button>
            {activeIndex === index && (
              <div className="faq-answer">
                <p>{item.answer}</p>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default FAQ;